import { Pipe, PipeTransform } from "@angular/core";

/**
 * Renders any payload as readable text: objects/arrays are pretty-printed JSON,
 * strings that contain JSON are parsed and pretty-printed, other strings are returned as-is.
 */
export function toPrettyJson(value: unknown): string {
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (
      (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
      (trimmed.startsWith("[") && trimmed.endsWith("]"))
    ) {
      try {
        return JSON.stringify(JSON.parse(trimmed), null, 2);
      } catch {
        return value;
      }
    }
    return value;
  }
  if (typeof value === "object") {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

@Pipe({
  name: "jsonPretty",
})
export class JsonPrettyPipe implements PipeTransform {
  transform(value: unknown): string {
    return toPrettyJson(value);
  }
}
